export const MAIN_LAYOUT_WIDTH = 768;
export const FULL_PAGES = ['About', 'Project', 'Blog', 'Contact'];
